<template>
    <v-form class="overwrite-inputs" ref="payform" v-model.trim="validPaymentForm" lazy-validation>
        <v-flex xs12 sm12 md12>
            <v-text-field label="Card Number" v-model.trim="cardNumber" :rules="cardNumberRules" required></v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md12>
            <v-text-field label="Full Name" v-model.trim="cardHolder" :rules="cardHolderRules" required></v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md12>
            <v-text-field label="Card Expiry" v-model.trim="cardExpiry" :rules="cardExpiryRules" v-mask="'##/##'" hint="MM/YY" persistent-hint required></v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md12>
            <v-text-field label="CVC" v-model.trim="cardCvc" :rules="cardCvcRules" required></v-text-field>
        </v-flex>
        <v-alert v-model="paymentAlert" dismissible dense outlined text type="error" class="mt-4 mb-0">Credit Card fields invalid.</v-alert>
    </v-form>
</template>

<script>
import { EventBus } from "@shared/EventBus.js";

export default {
    name: "MerchantWarrior",
    data() {
        return {
            validPaymentForm: false,

            cardNumber: "",
            cardNumberRules: [v => !!v || "Card Number is required"],
            cardHolder: "",
            cardHolderRules: [v => !!v || "Full Name is required"],
            cardExpiry: "",
            cardExpiryRules: [v => !!v || "Card Expiry is required"],
            cardCvc: "",
            cardCvcRules: [v => !!v || "CVC is required"],

            paymentAlert: false,
        };
    },
    methods: {
        clearPay() {
            this.paymentAlert = false;

            this.$refs.payform.reset();
        },
        submitPay: function() {
            if (this.$refs.payform.validate()) {
                this.validPaymentForm = false;
                this.paymentProcessing = true;

                const cardNumber = this.cardNumber;
                const cardName = this.cardHolder;
                const cardExpiry = this.cardExpiry;
                const cardCVC = this.cardCvc;

                this.$emit("submitted-pay", { cardNumber, cardName, cardExpiry, cardCVC });
            } else {
                this.paymentAlert = true;
            }
        },
    },
    created() {
        EventBus.$on("clear-pay", this.clearPay);
        EventBus.$on("submit-pay", this.submitPay);
    },
    beforeDestroy() {
        EventBus.$off("clear-pay");
        EventBus.$off("submit-pay");
    },
};
</script>

<style scoped></style>
